import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TripViewDashboardComponent } from './trip-view/components/trip-view-dashboard/trip-view-dashboard.component';
import { TripViewCabComponent } from './trip-view-cab/components/trip-view-cab/trip-view-cab.component'
import { DutyViewComponent } from './duty-view/components/duty-view/duty-view.component'
import { TripReplayComponent } from './trip-replay/components/trip-replay/trip-replay.component';
import { TripReplayCabComponent } from './trip-replay-cab/components/trip-replay-cab/trip-replay-cab.component';
import { AppComponent } from './app.component';
// import { MultiTripViewParamsResolver } from './multi-trip-view/resolver/multi-trip-view-params.resolver';
import { TripReplayConfigResolver } from './resolver/trip-replay-config.resolver';
import { ErrorPageComponent } from './error-page/error-page.component';
import { PageNotFound } from './page-not-found/page-not-found';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AppComponent
  },
  {
    path: 'trip-view/shuttle',
    pathMatch: 'full',
    component: TripViewDashboardComponent,
  },
  {
    path: 'duty-view',
    pathMatch: 'full',
    component: DutyViewComponent,
  },
  {
    path: 'trip-view/trip-replay',
    title: 'Trip Replay Shuttle',
    pathMatch: 'full',
    component: TripReplayComponent,
    resolve:[TripReplayConfigResolver]
  },
  {
    path: 'trip-view/cab',
    pathMatch: 'full',
    component: TripViewCabComponent,
  },
  {
    path: 'trip-view/trip-replay-cab',
    title: 'Trip Replay Cab',
    pathMatch: 'full',
    component: TripReplayCabComponent,
    resolve:[TripReplayConfigResolver]
  },
  {
    path: 'multi-trip-view',
    title: 'Modern Multi Trip View',
    pathMatch: 'full',
    loadChildren: () => import('./modern-multi-trip-view/modern-multi-trip-view.module').then(m => m.ModernMultiTripViewModule),
  },

  {
    path: 'route-replay',
    title: 'Route Replay',
    loadChildren: () => import('./route-replay/route-replay.module').then(m => m.RouteReplayModule),
  },
  {
    path : 'error',
    title: 'Unauthorized',
    component : ErrorPageComponent
  }, {
    path : "**",
    title:"404 - Not found",
    component : PageNotFound
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers:[TripReplayConfigResolver]
})
export class AppRoutingModule { }
